import { Link } from "react-router-dom";
import { ArrowUpRight, ShieldCheck } from "lucide-react";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { Reveal } from "@/components/Reveal";
import { legalList, LEGAL_VERSION, LEGAL_EFFECTIVE_DATE } from "@/data/legal";

export default function LegalCenter() {
  return (
    <main className="min-h-screen" data-testid="legal-center-page">
      <Nav />
      <div className="mx-auto max-w-4xl px-6 pb-24 pt-36 sm:pt-44">
        <Reveal>
          <p className="label-tech text-[#00F0FF]">JomKonvoi</p>
          <h1 className="mt-4 font-display text-5xl font-black tracking-tighter text-white sm:text-6xl">
            Legal Center
          </h1>
          <p className="mt-5 max-w-xl text-base leading-relaxed text-neutral-400">
            The same documents you'll find inside the JomKonvoi app — public, no sign-in needed.
            Version {LEGAL_VERSION}, effective {LEGAL_EFFECTIVE_DATE}.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-4 py-2" data-testid="legal-version-badge">
            <ShieldCheck className="h-4 w-4 text-[#00F0FF]" />
            <span className="font-mono-plex text-xs text-neutral-300">
              v{LEGAL_VERSION} · Effective {LEGAL_EFFECTIVE_DATE}
            </span>
          </div>
        </Reveal>

        <div className="mt-14 space-y-4">
          {legalList.map((doc, i) => (
            <Reveal key={doc.slug} delay={i * 0.08}>
              <Link
                to={doc.path}
                className="group flex items-center justify-between gap-6 rounded-2xl border border-white/10 bg-white/[0.03] p-6 transition-colors duration-300 hover:border-[#FF3333]/40 hover:bg-white/[0.05] sm:p-8"
                data-testid={`legal-card-${doc.slug}`}
              >
                <div>
                  <h2 className="font-display text-2xl font-bold tracking-tight text-white sm:text-3xl">
                    {doc.title}
                  </h2>
                  <p className="mt-2 max-w-lg text-sm leading-relaxed text-neutral-400">{doc.summary}</p>
                </div>
                <ArrowUpRight className="h-6 w-6 shrink-0 text-neutral-500 transition-all duration-300 group-hover:-translate-y-1 group-hover:translate-x-1 group-hover:text-[#FF3333]" />
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
      <Footer />
    </main>
  );
}
